import script from "./NotarialActionAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./NotarialActionAttachments.vue?vue&type=script&setup=true&lang=js"

import "./NotarialActionAttachments.vue?vue&type=style&index=0&id=2f951458&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f951458"]])

export default __exports__